import { providerTypes } from './providerTypes';
import ContratacionesLogo from '../assets/capweb/contrataciones.svg';
import AutorizacionesLogo from '../assets/capweb/autorizaciones.svg';
import LiquidacionesLogo from '../assets/capweb/liquidaciones.svg';
import ADPLogo from '../assets/capweb/adp.svg';
import DPPLogo from '../assets/capweb/datos personales.svg';
import DOCLogo from '../assets/capweb/documentacion.svg';
import DDALogo from '../assets/capweb/domicilios.svg';

export const permissions = {
  personalData: [providerTypes.PHYSICAL_PERSON, providerTypes.TEAM, providerTypes.INSTITUTION],
  documentation: [
    providerTypes.PHYSICAL_PERSON,
    providerTypes.TEAM,
    providerTypes.INSTITUTION,
    providerTypes.COLLEGE,
  ],
  serviceAddress: [providerTypes.PHYSICAL_PERSON, providerTypes.TEAM, providerTypes.INSTITUTION],
};

export const ADP_SERVICES = [
  {
    id: 'DPP',
    detalle: 'Datos personales y profesionales',
    tipos: permissions.personalData,
  },
  {
    id: 'DOC',
    detalle: 'Documentación',
    tipos: permissions.documentation,
  },
  {
    id: 'DDA',
    detalle: 'Domicilio de Atención',
    tipos: permissions.serviceAddress,
  },
];

export const sections = [
  {
    id: 'contratacions',
    title: 'Contrataciones',
    icon: ContratacionesLogo,
    testId: 'contrataciones-item',
  },
  {
    id: 'autorizaciones',
    title: 'Autorizaciones',
    icon: AutorizacionesLogo,
    testId: 'autorizaciones-item',
  },
  {
    id: 'liquidaciones',
    title: 'Liquidaciones',
    icon: LiquidacionesLogo,
    testId: 'liquidaciones-item',
  },
  {
    id: 'adp',
    title: 'Actualización de datos',
    icon: ADPLogo,
    testId: 'actualizacion-item',
    children: [
      {
        id: 'dpp',
        title: 'Datos Personales y Profesionales',
        icon: DPPLogo,
        testId: 'personal-data-item',
      },
      {
        id: 'doc',
        title: 'Documentación',
        icon: DOCLogo,
        testId: 'documentation-item',
      },
      {
        id: 'dda',
        title: 'Domicilios de atención',
        icon: DDALogo,
        testId: 'address-atention-item',
      },
    ],
  },
];

export const TabIds = {
  TRANSACTION: 'transaction',
  STATUS: 'transaction_status',
  INBOX: 'inbox',
};

export const tabTitles = {
  [TabIds.TRANSACTION]: 'Alta de trámites',
  [TabIds.STATUS]: 'Estado de Trámites',
  [TabIds.INBOX]: 'Inbox',
};

export const maritalStatuses = [
  { id: 1, label: 'Soltero' },
  { id: 2, label: 'Casado' },
  { id: 3, label: 'Divorciado' },
  { id: 4, label: 'Separado' },
  { id: 5, label: 'Viudo' },
];

export const genres = [
  { value: 'M', label: 'Masculino', key: 'M' },
  { value: 'F', label: 'Femenino', key: 'F' },
];

export const unselected = {
  mostrar: true,
  value: null,
  label: 'Seleccione',
};

export const documentTypes = [
  { id: 'DU', descripcion: 'DU' },
  { id: 'LC', descripcion: 'LC' },
  { id: 'LE', descripcion: 'LE' },
  { id: 'PA', descripcion: 'PA' },
  { id: 'CI', descripcion: 'CI' },
];
